import { STORAGE_KEY_ENUM } from 'enums';
import { Authentication, LocalStorage } from 'utils';
import axios, { AxiosInstance, AxiosResponse } from 'axios';

declare module 'axios' {
  interface AxiosResponse<T = any> extends Promise<T> {}

  interface AxiosRequestConfig {
    isPublicRequest?: boolean;
    suppressErrorNotification?: boolean;
  }
}

export abstract class HttpClient {
  protected readonly instance: AxiosInstance;

  public constructor(baseURL: string) {
    this.instance = axios.create({
      baseURL,
      headers: {
        Language: `TR`,
      },
    });

    this._initializeResponseInterceptor();
    this._initializeRequestInterceptor();
  }

  private _initializeResponseInterceptor = async () =>
    this.instance.interceptors.response.use(this._handleResponse, this._handleError);

  private _initializeRequestInterceptor = async () => {
    this.instance.interceptors.request.use((config) => {
      const token = LocalStorage.getItem(STORAGE_KEY_ENUM.TOKEN);
      const language = LocalStorage.getItem(STORAGE_KEY_ENUM.LANGUAGE)?.toUpperCase() || 'TR';

      config.headers.Language = language;

      if (token && !config.isPublicRequest) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    });
  };

  private _handleResponse = (response: AxiosResponse) => response.data;

  protected _handleError = (error: any) => {
    if (typeof window !== 'undefined') {
      if (error?.response?.status === 401 && !error?.config?.isPublicRequest) {
        Authentication.logOut();
      }

      const message = error?.response?.data?.Message ?? error?.response?.data?.message ?? error?.message;

      if (!error?.config?.suppressErrorNotification && message) {
        window.dispatchEvent(new CustomEvent('errorEvent', { detail: message }));
      }
    }

    return Promise.reject(error);
  };
}
